import { Component, OnInit } from '@angular/core';
import { Global } from '../global';

declare var $;

@Component({
  selector: 'app-apertura',
  templateUrl: './apertura.component.html',
  styleUrls: ['./apertura.component.scss']
})
export class AperturaComponent implements OnInit {

  paso = 1;
  apertura = false;
  formulario;
  poblaciones = [];
  cargando = false;
  subiendo_albaran = false;
  n_files = {};
  documentos = [];
  subiendo = {};
  files = [];

  constructor(public global: Global) { }

  ngOnInit() {

    this.documentos = [
      {
        nombre: 'Reclamación formal',
        id: 102
      },
      {
        nombre: 'Fotografías',
        id: 87
      },
      {
        nombre: 'Presupuesto',
        id: 101
      },
      {
        nombre: 'Factura de reparación',
        id: 83
      },
      {
        nombre: 'Certificado destrucción mercancía',
        id: 111
      },
      {
        nombre: 'Certificado acordado de no cobertura propia',
        id: 112
      },
      {
        nombre: 'Versión firmada del asegurado/trabajador',
        id: 113
      },
      {
        nombre: 'CPD trabajador cedido',
        id: 114
      },
      {
        nombre: 'Carnet de operador de carretillas',
        id: 115
      }
    ];
    this.init_formulario();

  }

  init_formulario() {

    this.formulario = {
      fecha: {
        value: '',
        error: null,
        paso: 1
      },
      dirPerjudicado: {
        value: '',
        error: null,
        paso: 1
      },
      cp: {
        value: '',
        error: null,
        paso: 1
      },
      poblacion: {
        value: '',
        error: null,
        paso: 1
      },
      circunstancias: {
        value: '',
        error: null,
        paso: 1
      },
      danos: {
        value: '',
        error: null,
        paso: 1
      },
      empresa: {
        value: '',
        error: null,
        paso: 2
      },
      nombre: {
        value: '',
        error: null,
        paso: 2,
      },
      apellido1: {
        value: '',
        error: null,
        paso: 2,
      },
      apellido2: {
        value: '',
        error: null,
        paso: 2,
      },
      telefono: {
        value: '',
        error: null,
        paso: 2
      },
      email: {
        value: '',
        error: null,
        paso: 2
      },
      sin_id: {
        value: '',
        error: null,
        paso: 3
      }
    };

    for(let doc of this.documentos){
      this.formulario[doc.nombre] = {
        value: [],
        error: null,
        id: doc.id,
        paso: 3
      }
      this.subiendo[doc.id] = false;
      this.n_files[doc.id] = 1;
    }

    this.paso = 1;
    this.poblaciones = [];
    this.files = [];

    setTimeout(() => {
      $("#fecha").datepicker({
        dateFormat: 'yy/mm/dd'
      });
      $('#docsTable').DataTable({
        lengthMenu: [20],
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json"
        },
      });
    }, 100);

  }

  existsFiles(name){
    if (this.files.filter(f => f.document == name).length == 0) {
      return false;
    }
    return true;
  }

  async subir_documentos(fileInput: any, documentName, docId) {

    this.subiendo[docId] = true;

    let files = <Array<File>>fileInput.target.files;

    for (let file of files) {

      this.files.push({
        file: file,
        name: file.name,
        document: documentName,
        nombre: documentName+'_'+this.n_files[docId].toString(),
        id: docId
      })

    }

    this.n_files[docId]++;

    $('input[type="file"]').val('');

    this.subiendo[docId] = false;

  }


  async comprobar_campos_paso1(evt = null) {

    if(evt) return false;

    let r = true;

    if (this.paso == 1) {

      this.formulario.fecha.value = $("#fecha").val();

      for (let campo in this.formulario) {

        if(campo == "poblacion") continue;

        if (this.formulario[campo].paso == 1) {

          this.formulario[campo].error = null;

          if (this.formulario[campo].value == "") {
            this.formulario[campo].error = "Rellena el campo";
            r = false;
          }


        }

      }

      let fecha = new Date(this.formulario.fecha.value);
      let hoy = new Date();
      let dias = Math.floor((fecha.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));

      if (dias >= 0) {
        this.formulario.fecha.error = "La fecha no puede ser posterior a hoy";
        r = false;
        //return r;
      }

      let c = await this.checkCP(this.formulario.cp.value);

      if(!c) r = false;

      if(this.formulario.poblacion.value == '' && this.poblaciones.length != 0){
        this.formulario.poblacion.value = this.poblaciones[0];
      } 
    }

    return r;

  }

  async comprobar_campos_paso2(evt = null) {

    if(evt) return false;

    let r = true;

    if(this.paso == 2) {

      for (let campo in this.formulario) {

        if (this.formulario[campo].paso == 2) {

          this.formulario[campo].error = null;

          if (this.formulario[campo].value == "") {
            this.formulario[campo].error = "Rellena el campo";
            r = false;
            //return r;
          }


        }

      }

      if (!(/^[\d]{3}[-]*([\d]{2}[-]*){2}[\d]{2}$/).test(this.formulario.telefono.value)) {

        this.formulario.telefono.error = "Introduzca un número de teléfono válido";
        r = false;
        //return r;

      }

      if(this.formulario.email.value != ''){
        if (!(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(this.formulario.email.value))) {

          this.formulario.email.error = "Introduzca un email válido";
          r = false;
          //return r;

        }
      }

    }

    return r;

  }

  async comprobar_campos_paso3(evt = null) {

    if(evt) return false;

    let r = true;

    if(this.paso == 3) {
      for(let doc of this.documentos){
        if (this.files.filter(f => f.document == doc.nombre).length == 0) {
          this.formulario[doc.nombre].error = "Por favor, adjunte al menos un documento";
          r = false;
        }
  
      }
    }

    return r;

  }

  async paso2() {

    let c = await this.comprobar_campos_paso1();

    if (!c) return;

    this.paso = 2;

  }

  async paso3(){

    let c = await this.comprobar_campos_paso2();

    if (!c) return;

    setTimeout(() => {
      
    },100);

    this.paso = 3;
  }

  clickInput(input){
    document.getElementById("input_"+input).click();
  }

  abrir_documento(file) {

    window.open(file.url);

  }

  aperturar() {
    this.init_formulario();
    this.apertura = true;
  }

  cancelarApertura() {
    this.apertura = false;
  }

  async checkCP(cp) {

    this.poblaciones = [];

    this.formulario.cp.error = null;

    if(this.formulario.cp.value == "") {

      this.formulario.cp.error = "Rellena el campo";
      return false;

    } else if (isNaN(parseFloat(this.formulario.cp.value))) {

      this.formulario.cp.error = "Introduzca un código postal válido";
      return false;

    } else if (this.formulario.cp.value.length != 5) {

      this.formulario.cp.error = "Introduzca un código postal válido";
      return false;

    }

    this.cargando = true;
    let result = await this.global.apiCall("eurofirms/checkCP", "POST", false, { cp: cp });
    this.cargando = false;

    if (!result.status) {

      this.formulario.cp.error = result.message;
      return false;

    }

    this.poblaciones = result.data;

    return true;

  }

  uploadFile(file, name) {

    let size = file.size / 1024 / 1014;

    if(size >= 20) {
      return {
        status: false,
        message: "No se pueden subir archivos con un tamaño superior a 20Mb"
      };
    }

    var formData = new FormData();

    formData.append('select_file', file, file.name);
    formData.append('file_name', name);
    formData.append('sin_id', this.formulario.sin_id.value);

    return $.ajax({
      url: this.global.config.api + 'eurofirms/uploadFile',
      method: "POST",
      data: formData,
      dataType: 'JSON',
      contentType: false,
      cache: false,
      processData: false
    });

  }

  async delete_file(key, i) {

    this.files.splice(i, 1);

  }

  async uploadDocumentos(){

    for(let file of this.files){
      this.cargando = true;

      let result = await this.uploadFile(file.file, file.nombre);

      this.cargando =  false;

      if (result.message) {
        alert("Se ha producido un error en la subida de documentos");
        return;
      }

      let url = result.url;
      let new_name = result.new_name;

      let type = file.file.type.split('/')[0];

      this.formulario[file.document].value.push({
        url: url,
        type: type,
        name: file.name,
        new_name: new_name
      });
    }    
  }

  async grabar_siniestro() {

    // let c = await this.comprobar_campos_paso3();

    // if (!c) {

    //   alert("Comprueba los datos introducidos");
    //   return;

    // } 

    this.cargando = true;

    let data = {};
    for (let campo in this.formulario) {

      if(this.formulario[campo].paso != 3) data[campo] = this.formulario[campo].value;

    }

    let result = await this.global.apiCall("eurofirms/grabar_siniestro", "POST", false, data);
    this.cargando = false;

    if (!result.status) {
      alert(result.message);
    } else {

      this.formulario.sin_id.value = result.data;

      await this.uploadDocumentos();
  
      this.cargando = true;
  
      data = {};
  
      for (let campo in this.formulario) {
  
        if (this.formulario[campo].paso != 3) continue;
  
        data[campo] = this.formulario[campo].value;
  
      }
  
      result = await this.global.apiCall("eurofirms/cargarFicheros", "POST", false, {data: data, docs: this.documentos});
  
      this.cargando = false;
  
      if (!result.status) {
  
        alert(result.message);
        return;
  
      }
  
      this.paso = 4;

    }

  }

}
